export default __webpack_public_path__ + "static/media/BethLovelace.16181498.png";